<template>
  <div class="table-responsive">
    <div v-if="reports.length > 0">
      <table class="table table-hover table-bordered" id="example">
        <thead>
          <tr>
            <th>Customer</th>
            <th>Loan Amount</th>
            <th>Status</th>
            <th>Paid Charges</th>
            <th>Total Charges</th>
            <th>Outstanding Balance</th>
            <th>Is Disbursed</th>
            <th>Expected Total Interest</th>
            <th>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(report, index) in reports" :key="index">
            <td>{{ report.customer.first_name }} {{ report.customer.last_name }}</td>
            <td>{{ report.loan_amount }}</td>
            <td>{{ report.status }}</td>
            <td>{{ report.paid_charges }}</td>
            <td>{{ report.total_charges }}</td>
            <td>{{ report.outstanding_balance }}</td>
            <td>{{ report.is_disbursed }}</td>
            <td>{{ report.expected_total_interest }}</td>

            <td>
              <router-link
                :event="permissions.includes('view-transaction') ? 'click' : ''"
                class="button"
                :class="
                  permissions.includes('view-transaction')
                    ? ''
                    : 'disabled cursor-not-allowed'
                "
                :to="{ name: 'LoanComponent', params: { slug: report.id } }"
              >
                View Loan
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import Swal from "sweetalert2";
export default {
  props: {
    start_date: {
      type: String,
      default: "",
      required: false
    },
    stop_date: {
      type: String,
      default: "",
      required: false
    },
    search: {
      type: String,
      default: "",
      required: false
    },
    plan: {
      type: String,
      default: "",
      required: false
    },
    reportURL: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      reports: []
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.userObj.admin.permissions;
      return permissions;
    }
  },
  methods: {
    async getReports() {
      console.log(this.start_date, this.stop_date, this.search, this.plan);
      this.reports = [];
      try {
        const response = await ApiService.get(this.reportURL);
        console.log("response", response, response.data.data.length);

        // this.$store.commit("setReportsLoading", false);
        if (response.data.data.length > 0) {
          this.reports = response.data.data;
          setTimeout(function() {
            // eslint-disable-next-line no-undef
            $("#example").DataTable({
              pagingType: "numbers",
              pageLength: 100,
              retrieve: true,
              responsive: true,
              processing: true,
              dom: "Bfrtip",
              buttons: ["copy", "csv", "print"]
            });
          }, 1000);
        } else {
          this.plan = "";
          this.search = "";
          Swal.fire({
            title: "Info!",
            icon: "info",
            text: "No Result Founds...",
            timer: 3000,
            timerProgressBar: true
          });
          // this.getReports();
        }
      } catch (error) {
        // this.$store.commit("setReportsLoading", false);
        this.reports = [];
        let _error = error.response;
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: _error.data
            ? _error.data.response_description
            : "Server Error, Try Again"
        });
      }
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    console.log($("#example"));
    this.getReports();
  }
};
</script>

<style scoped>
#dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-style: solid;
  border-width: 4px;
  border-radius: 100%;
  /* color: red; */
}
</style>
